var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 8,
    viewBox: "0 0 23 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28033 0.46967C4.57322 0.762563 4.57322 1.23744 4.28033 1.53033L2.56066 3.25H20.4393L18.7197 1.53033C18.4268 1.23744 18.4268 0.762563 18.7197 0.46967C19.0126 0.176777 19.4874 0.176777 19.7803 0.46967L22.7803 3.46967C23.0732 3.76256 23.0732 4.23744 22.7803 4.53033L19.7803 7.53033C19.4874 7.82322 19.0126 7.82322 18.7197 7.53033C18.4268 7.23744 18.4268 6.76256 18.7197 6.46967L20.4393 4.75H2.56066L4.28033 6.46967C4.57322 6.76256 4.57322 7.23744 4.28033 7.53033C3.98744 7.82322 3.51256 7.82322 3.21967 7.53033L0.21967 4.53033C-0.0732233 4.23744 -0.0732233 3.76256 0.21967 3.46967L3.21967 0.46967C3.51256 0.176777 3.98744 0.176777 4.28033 0.46967Z",
    fill: "#303757",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.bf19b88524847da27fbc405d5d30ee29.svg";
export { ForwardRef as ReactComponent };